// Si el formulario es inválido, el foco va al primer campo con error para que se anuncie.
export default {
    methods: {
        async validateForm () {
            await this.$validator.validateAll();

            if (!this.errors.any()) return true;

            this.$nextTick(() => {
                const field = this.$el.querySelector('[aria-invalid="true"]');
                if (field && field.offsetParent !== null) field.focus();
            });

            return false;
        },
    },
};
